
export const SET_LANG = "SET_LANG";
export const SET_USER = "SET_USER";
export const SET_TOS = "SET_TOS";